<template>
  <el-dialog
      v-el-drag-dialog
      class="ProductionOrderPreview"
      :visible.sync="dialogVisible"
      top="2vh"
      title="生产工单详情"
      width="1200px">
    <div>
      <div class="title">基本信息</div>
      <table style="width: 100%" cellpadding="0" cellspacing="0">
        <tr>
          <td class="tableTitle">工单类型</td>
          <td>{{orderInfo.prodOrderTypeName}}</td>
          <td class="tableTitle">销售订单</td>
          <td>{{orderInfo.salesOrderNo}}</td>
          <td  class="tableTitle">ERP销售订单</td>
          <td>{{orderInfo.erpSalesOrderNo}}</td>
        </tr>
        <tr>
          <td class="tableTitle">派工单号</td>
          <td>{{orderInfo.billNo}}</td>
          <td class="tableTitle">工单编号</td>
          <td>{{orderInfo.productionOrderNo}}</td>
          <td class="tableTitle">物料编号</td>
          <td>{{orderInfo.materialNo}}</td>
        </tr>
        <tr>
          <td class="tableTitle">物料名称</td>
          <td>{{orderInfo.materialName}}</td>
          <td class="tableTitle">规格型号</td>
          <td>{{orderInfo.specification}}</td>
          <td class="tableTitle">工作中心</td>
          <td>{{orderInfo.workCenterName}}</td>
        </tr>
        <tr>
          <td class="tableTitle">发料状态</td>
          <td>{{orderInfo.feedingStatusName}}</td>
          <td class="tableTitle">派工单数量</td>
          <td>{{orderInfo.quantity}}</td>
          <td class="tableTitle">工单状态</td>
          <td>{{orderInfo.statusName}}</td>
        </tr>
        <tr>
          <td class="tableTitle">计划开工时间</td>
          <td>{{orderInfo.planStartTime}}</td>
          <td class="tableTitle">计划完工时间</td>
          <td>{{orderInfo.planFinishTime}}</td>
          <td class="tableTitle">要求交期</td>
          <td>{{orderInfo.deliveryDate}}</td>
        </tr>
        <tr>
          <td class="tableTitle">合同号</td>
          <td>{{orderInfo.customerContractNo}}</td>
          <td class="tableTitle">客户名称</td>
          <td>{{orderInfo.customerName + "(" + orderInfo.customerOuterNo + ")"}}</td>
          <td class="tableTitle">项目名称</td>
          <td>{{orderInfo.projectName}}</td>
        </tr>
      </table>
      <!--      <div class="title" style="margin-top: 20px">生产条码</div>-->
      <!--      <material-code-list :pkid="orderInfo.pkid" :order-info="orderInfo"/>-->
      <div class="title" style="margin-top: 20px">生产过程</div>
      <product-process :pkid="orderInfo.pkid" :order-info="orderInfo"/>
      <div/>
    </div>
  </el-dialog>
</template>

<script>
  // import MaterialCodeList from "./MaterialCodeList";
  import ProductProcess from "./ProductProcess";

  export default {
    name: "ProductionOrderPreview",
    components: {
      // MaterialCodeList,
      ProductProcess,
    },

    data() {
      return {
        dialogVisible: false,
        orderInfo: {},
      };
    },
    methods: {
      open(row) {
        this.dialogVisible = true;
        this.orderInfo = row;
      },
      close() {
        this.dialogVisible = false;
        this.orderInfo = {};
      },
    },
  };
</script>

<style lang="scss" scoped>
.title {
  border-bottom: 1px solid #ddd;
  margin-bottom: 10px;
  padding-bottom: 5px;
  font-size: 16px;
}

table td {
  border: 1px solid #dddddd;
  border-bottom: none;
  border-right: none;
  padding: 10px;
  font-size: 12px;
}

table tr:last-child td {
  border-bottom: 1px solid #dddddd;
}

table tr td:last-child {
  border-right: 1px solid #dddddd;
}

.tableTitle {
  background-color: #d1e6f5;
  text-align: right;
  width: 100px;
}
</style>
